import { layout, moduleRoute } from '@src/helper/routes'
import type { Router } from 'vue-router'

export default (router: Router) => {
    router.addRoute(
        layout(
            'Login',
            'CRMStaticForms',
            [
                moduleRoute('CRM', 'CampaignForm', '/crm/campaign/:id'),
                moduleRoute(
                    'CRM',
                    'CampaignContacted',
                    '/crm/campaign/contacted'
                ),
            ],
            '/crm'
        )
    )
}
